export default __webpack_public_path__ + "static/media/photo--lg--30.e1eca644.jpg";